module.exports = __webpack_public_path__ + "static/dotted-mask-65ffad3e7c9909b0254fec9ffcb8f08c.svg";